import { colors } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Home() {

    const { t } = useTranslation();
    return (
        <div id="home" className="position-relative">

            <div id="home-bg" className="item" style={{ backgroundImage: 'url("/img/home_background.png")', backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '70vh', display: 'flex', alignItems: 'center' }}>
                <div className="about-font-style">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-sm-12 mb-3">
                                <div className="d-flex align-items-center justify-content-center h-100">
                                    <div className="tw-mx-10">
                                        <h1 className=" mb-3 tw-font-bold tw-text-4xl" style={{ color: "#0e8858" }}  >
                                            <b>
                                                {t("home-header")}
                                            </b></h1>
                                        <p className="text-white tw-text-sm tw-leading-relaxed">
                                            {t("home-content")}</p>
                                        <div className="tw-mt-6">
                                            <a href="#sysIntro" className="btn btn-danger text-white tw-font-semibold tw-px-6 tw-py-2 tw-rounded-lg hover:tw-opacity-90 tw-transition-opacity">
                                                {t("System Intro")}
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
